module.exports = __webpack_public_path__ + "img/chart_white.c5ec38de.svg";